import { render, staticRenderFns } from "./OpsViewTabs.vue?vue&type=template&id=fe8ca478&scoped=true"
import script from "./OpsViewTabs.vue?vue&type=script&lang=js"
export * from "./OpsViewTabs.vue?vue&type=script&lang=js"
import style0 from "./OpsViewTabs.vue?vue&type=style&index=0&id=fe8ca478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8ca478",
  null
  
)

export default component.exports